import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

// Domains section buttons share the main app's .xp-btn look (styles/xp-shell.css);
// dm-* modifiers live in domains/dm.css. API is the shadcn one, so pages are unchanged.
const buttonVariants = cva(
  "xp-btn whitespace-nowrap disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "xp-btn-primary",
        destructive: "dm-btn-danger",
        outline: "",
        secondary: "dm-btn-secondary",
        ghost: "dm-btn-ghost",
        link: "dm-btn-link",
      },
      size: {
        default: "",
        sm: "dm-btn-sm",
        lg: "dm-btn-lg",
        icon: "dm-btn-icon",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
